import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Styles/Sidebar.css";
import { icons } from "../Assests/icons-imports/icons";
import {
  AlertOutlined,
  ApartmentOutlined,
  ApiOutlined,
  BarChartOutlined,
  BellOutlined,
  ChromeOutlined,
  ContactsOutlined,
  DatabaseOutlined,
  FileDoneOutlined,
  FormOutlined,
  HistoryOutlined,
  HomeOutlined,
  LineChartOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MessageOutlined,
  MoneyCollectOutlined,
  ProfileOutlined,
  RadiusSettingOutlined,
  RetweetOutlined,
  RiseOutlined,
  SettingOutlined,
  SnippetsOutlined,
  SunOutlined,
  UploadOutlined,
  UserAddOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  UserSwitchOutlined,
  VideoCameraAddOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { Button, Layout, Menu, theme } from "antd";
import courses_icon from "../Assests/Icons/courses_icon.png";
import bell_icon from "../Assests/Icons/bell_icon.png";
import user_icon from "../Assests/Icons/user_icon.png";
import questionmark_icon from "../Assests/Icons/questionmark_icon.png";
import ninedots_icon from "../Assests/Icons/ninedots_icon.png";
import LOGO from "../Assests/images/logo3.png";
import "../Styles/Navbar.css";
import { useNavigate } from "react-router-dom";
import ProfileMenu from "./ProfileSection/ProfileMenu";

const { Header, Sider, Content } = Layout;

const Sidebar = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate()
  const [collapsed, setCollapsed] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(true)
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const handleClickDashboard = () => {
    navigate('/dashboard');
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleLogout = () => {
    navigate('/')
    console.log("user logout ")
  }

  return (
    <>
      <Header className="header_main">
        <div className="header_section">
          <div className="header_left">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />
            <img src={LOGO} alt="alt" width={200} className="move-dashboard"
              onClick={handleClickDashboard}
            />
          </div>
          <div className="header_right">
            <img src={bell_icon} alt="icon" className="navbar_right_icon" />
            {/* <img src={user_icon} alt="icon" className="navbar_right_icon" /> */}
            <ProfileMenu />
          </div>
        </div>
      </Header>
      <Layout>
        <Sider trigger={null} collapsible collapsed={collapsed}     >
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={["13"]}
            items={
              [
                {
                  key: 13,
                  icon: <UserOutlined />,
                  label: (
                    <Link to={"/director-dashboard"} className="text-decoration-none">
                      Director Dashbaord
                    </Link>
                  )
                },
                {
                  key: 14,
                  icon: <RetweetOutlined />,
                  label: (
                    <Link to={"/employee-exchange"} className="text-decoration-none">
                      Employee Exchange
                    </Link>
                  )
                },
                {
                  key: 15,
                  icon: <RiseOutlined />,
                  label: (
                    <Link to={"/skill-development"} className="text-decoration-none">
                      Skill Devlopment
                    </Link>
                  )
                },
              ]}
          />
        </Sider >
        <Layout>
          <Content
            style={{
              marginTop: -50,
              padding: 0,
              minHeight: 280,
              borderRadius: borderRadiusLG,
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout >
    </>
  );
};

export default Sidebar;
